import {
  bootstrapToggleOff,
  bootstrapToggleOn,
} from '@ng-icons/bootstrap-icons';
import {
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroChevronUp,
  heroChevronDown,
  heroUsers,
  heroPlus,
  heroArrowLeft,
  heroArrowRight,
  heroPaperAirplane,
  heroBars3,
  heroFunnel,
  heroArrowPath,
  heroBuildingOffice,
  heroArchiveBox,
  heroTrophy,
  heroListBullet,
  heroReceiptPercent,
  heroPlayCircle,
  heroPauseCircle,
  heroClipboardDocumentList,
  heroLink,
  heroUser,
  heroArrowLeftStartOnRectangle,
  heroArrowUturnLeft,
  heroArrowUturnRight,
  heroInformationCircle,
  heroChatBubbleLeftEllipsis,
  heroShieldCheck,
  heroCog8Tooth,
  heroArrowDownTray,
  heroArrowRightStartOnRectangle,
  heroExclamationTriangle,
  heroMapPin,
  heroSignalSlash,
  heroBattery0,
  heroShieldExclamation,
  heroDocumentArrowDown,
  heroPencilSquare,
  heroDocument,
  heroChevronLeft,
  heroCurrencyDollar,
  heroClock,
  heroVideoCamera,
  heroBell,
  heroBolt,
  heroLockClosed,
  heroQrCode,
  heroLockOpen,
  heroArrowTopRightOnSquare,
  heroDocumentText,
  heroPrinter,
  heroFolder,
  heroCheckCircle,
  heroArrowUpTray,
  heroCalendar,
  heroCog6Tooth,
  heroXMark,
  heroCheck,
  heroEnvelope,
  heroPhone,
  heroHashtag,
  heroStop,
  heroSquare2Stack,
  heroSquares2x2,
  heroCircleStack,
  heroDocumentCheck,
  heroClipboardDocumentCheck,
  heroXCircle,
  heroArrowRightOnRectangle,
  heroPhoto,
  heroPaperClip,
  heroChatBubbleLeftRight,
  heroPresentationChartBar,
} from '@ng-icons/heroicons/outline';

export const ICONS = {
  heroPencil,
  heroTrash,
  heroEye,
  heroChevronUpDown,
  heroChevronUp,
  heroChevronDown,
  heroUsers,
  heroPlus,
  heroArrowLeft,
  heroPaperAirplane,
  heroBars3,
  heroFunnel,
  heroArrowPath,
  heroBuildingOffice,
  heroArchiveBox,
  heroTrophy,
  heroListBullet,
  heroReceiptPercent,
  heroPlayCircle,
  heroPauseCircle,
  bootstrapToggleOff,
  bootstrapToggleOn,
  heroClipboardDocumentList,
  heroLink,
  heroUser,
  heroArrowLeftStartOnRectangle,
  heroArrowUturnLeft,
  heroArrowUturnRight,
  heroInformationCircle,
  heroChatBubbleLeftEllipsis,
  heroShieldCheck,
  heroCog8Tooth,
  heroArrowDownTray,
  heroArrowRightStartOnRectangle,
  heroExclamationTriangle,
  heroMapPin,
  heroSignalSlash,
  heroBattery0,
  heroShieldExclamation,
  heroDocumentArrowDown,
  heroPencilSquare,
  heroDocument,
  heroChevronLeft,
  heroCurrencyDollar,
  heroClock,
  heroVideoCamera,
  heroBell,
  heroBolt,
  heroLockClosed,
  heroQrCode,
  heroLockOpen,
  heroArrowTopRightOnSquare,
  heroDocumentText,
  heroPrinter,
  heroFolder,
  heroCheckCircle,
  heroArrowUpTray,
  heroCalendar,
  heroCog6Tooth,
  heroXMark,
  heroCheck,
  heroEnvelope,
  heroPhone,
  heroHashtag,
  heroStop,
  heroArrowRight,
  heroSquare2Stack,
  heroSquares2x2,
  heroCircleStack,
  heroDocumentCheck,
  heroClipboardDocumentCheck,
  heroXCircle,
  heroArrowRightOnRectangle,
  heroPhoto,
  heroPaperClip,
  heroChatBubbleLeftRight,
  heroPresentationChartBar,
};
